import React,{ Component,Fragment } from 'react';
import remove from '../../../Public/Images/remove.svg';
import settings from '../../../Public/Images/settings.svg';
import parent from '../../../Public/Images/parent.svg';
import move from '../../../Public/Images/move.svg';


class HtmlElement extends Component{

    constructor(props){
        super(props);
    }

    render(){

        const {element,showHelpers,cm,lastIndexes,lang} = this.props;
        var parentIndexes = "";
        
        var indexes = lastIndexes.split("-");
        if(indexes.length > 2){
            indexes.pop();
            parentIndexes = indexes.join("-");
        }

        return (
            <div className="cm-headline">

                {showHelpers && element.showMenu &&
                    <div className="cm-menu" onClick={(e) => e.stopPropagation()}>
                        <div className="form-inline">
                            
                            <div className="form-group mr-1">
                                <div className="item-container" onClick={() => cm.showSettings("html",lastIndexes)}>
                                    <img className="remove-icon" src={settings} alt="Nastavení modulu" title="Nastavení modulu" />
                                </div>
                                {element.showSettings &&
                                    <Fragment>
                                        <div className="settings">

                                            <div className="mb-1">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <label className="input-group-text">Přeložit pouze toto:</label>
                                                    </div>
                                                    <select 
                                                        value={element.selectedForGenerateTranslation ? 1 : 0} 
                                                        className="form-control" 
                                                        name="selectedForGenerateTranslation" 
                                                        onChange={(e) => cm.setElementData(e,lastIndexes,"html")}
                                                    >
                                                        <option value="0"> Ne </option>
                                                        <option value="1"> Ano </option>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            <div className="mb-1">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <label className="input-group-text">Typ:</label>
                                                    </div>
                                                    <select value={element.type} className="form-control" name="type" onChange={(e) => cm.setElementData(e,lastIndexes,"html")}>
                                                        <option value="html"> HTML </option>
                                                        <option value="preview"> Náhled </option>
                                                    </select>
                                                </div>
                                            </div>
                                                                                       
                                        </div>
                                        <div className="cm-closing-overlay" onClick={() => cm.showSettings("html",lastIndexes)}></div>
                                    </Fragment>
                                }
                            </div>
                            {parentIndexes != "" &&
                                <div className="form-group mr-1">
                                    <div className="item-container" onClick={(e) => cm.selectElement(e,cm.columnColType,parentIndexes)}>
                                        <img className="remove-icon" src={parent} alt="Nadřazený element" title="Nadřazený element" />
                                    </div>
                                </div>
                            }
                            <div className="form-group">
                                <div className="item-container" onClick={() => cm.removeElement(lastIndexes)}>
                                    <img className="remove-icon"  src={remove} alt="Odstranit html" title="Odstranit html" />
                                </div>
                            </div>
                        </div>  
                    </div>
                }

                <div className="cm-headline-content" onClick={(e) => {e.stopPropagation(); !element.showMenu && cm.selectElement(e,"html",lastIndexes)}}>
                    {element.type == "html" ?

                        <textarea style={{width:"100%"}} placeholder="HTML kód" value={element.code[lang]} name="code" onChange={(e) => cm.setElementData(e,lastIndexes,"html",null,null,true)}></textarea>

                    :
                        <div dangerouslySetInnerHTML={{__html:element.code[lang]}}></div>

                    }
                </div>
                {showHelpers && <div className={"cm-border" + (element.showMenu ? " cm-selected" : "")}></div>}
                {showHelpers && 
                    <div className="cm-dragable-item" {...this.props.handle}>
                        <div className="item-container">
                            <img className="move-icon"  src={move} alt="Přesunout element" title="Přesunout element" />
                        </div>
                    </div>
                }

            </div>
        );

    }
}

export default HtmlElement;